import styled from 'styled-components';
import { Button } from '~/components';
import { HistoryGraphContainer, HistoryGraphLoading } from '../../styles';

export const CardsContainerLoading = styled(HistoryGraphLoading)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .skeleton-span {
    width: 500px;
  }
`;

export const WaterContainer = styled(CardsContainerLoading)`
  margin-top: 0;
  flex-direction: column;
  gap: 10px;
  align-items: start;
  justify-content: flex-start;
`;

export const WaterCardContainer = styled(HistoryGraphContainer)<{ expanded?: boolean }>`
  gap: 14px;
  height: 364px;

  ${({ expanded }) => (expanded ? '' : `
    width: 500px;
  `)}
`;

export const CardsGraphContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100%;
  flex: 1;
  gap: 8px;
`;

export const DetailsButton = styled(Button)`
  height: 25px;
  width: 92px;
`;

export const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ContentImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  border-radius: 8px;
  opacity: 0.6;
  filter: blur(3px);
`;

export const BadgeContainer = styled.div`
  margin-left: auto;
  position: absolute;
  top: 5px;
  right: 12px;
`;
